import React from "react";
import { Link } from "react-router-dom";
import "../styles/Club.css";

const Club = () => {
    return (
        <div className="club-container">
            <h1 className="club-title">🎉 Club Bibas</h1>

            <p className="club-intro">
                Únete a nuestro club exclusivo y disfruta de recompensas únicas que hemos preparado para ti. Conviértete en un verdadero VIP de Bibas.
            </p>

            <h2 className="club-subtitle">🎁 Beneficios para miembros:</h2>
            <ul className="club-benefits">
                <li>⭐ Gana el doble de sellos loyaly por cada compra</li>
                <li>🔒 Acceso a promociones exclusivas solo para miembros</li>
                <li>🎲 Participación automática en sorteos mensuales</li>
                <li>🎂 Regalo especial en tu cumpleaños</li>
                <li>💬 Canal exclusivo de WhatsApp para miembros.</li>
                <li>🚀 Acceso anticipado a lanzamientos de nuevos productos</li>
                <li>🎟️ Invitaciones a eventos privados</li>
                <li>🧢 Merch exclusiva: ¡recibe tu gorra del club al registrarte!</li>
            </ul>

            <h2 className="club-subtitle">📌 ¿Cómo unirte?</h2>
            <ol className="club-steps">
                <li>1️⃣ Regístrate en nuestra plataforma si aún no lo has hecho.</li>
                <li>2️⃣ Solicita tu membresía del Club Bibas por <strong>$50 anuales</strong>.</li>
                <li>3️⃣ Recibe tu tarjeta personalizada y una gorra exclusiva del club.</li>
            </ol>

            <div className="club-cta">
                <Link to="/register" className="club-button">Registrarme</Link>
                <a
                    href="https://wa.me/584146030657?text=Hola%2C%20quiero%20unirme%20al%20Club%20Bibas%20y%20pagar%20mi%20membres%C3%ADa%20anual%20de%2050%20USD."
                    className="club-button secondary"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Pagar membresía
                </a>
            </div>
        </div>
    );
};

export default Club;
